var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7779 4.44446H5.77794C5.66007 4.44446 5.54702 4.49128 5.46367 4.57463C5.38032 4.65798 5.3335 4.77103 5.3335 4.8889V14.6667C5.3335 14.7846 5.38032 14.8976 5.46367 14.981C5.54702 15.0643 5.66007 15.1111 5.77794 15.1111H13.7779C13.8958 15.1111 14.0089 15.0643 14.0922 14.981C14.1756 14.8976 14.2224 14.7846 14.2224 14.6667V4.8889C14.2224 4.77103 14.1756 4.65798 14.0922 4.57463C14.0089 4.49128 13.8958 4.44446 13.7779 4.44446ZM12.4446 11.5556H7.11127V10.6667H12.4446V11.5556ZM12.4446 9.77779H7.11127V8.8889H12.4446V9.77779ZM12.4446 8.00001H7.11127V7.11112H12.4446V8.00001Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66672 10.6667V1.7778H10.6667V1.33336C10.6667 1.21549 10.6199 1.10244 10.5365 1.01909C10.4532 0.935741 10.3402 0.888916 10.2223 0.888916H2.22228C2.1044 0.888916 1.99136 0.935741 1.90801 1.01909C1.82466 1.10244 1.77783 1.21549 1.77783 1.33336V11.1111C1.77783 11.229 1.82466 11.3421 1.90801 11.4254C1.99136 11.5088 2.1044 11.5556 2.22228 11.5556H2.66672V10.6667Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44455 12.4445V3.55558H12.4446V3.11113C12.4446 2.99326 12.3977 2.88021 12.3144 2.79686C12.231 2.71351 12.118 2.66669 12.0001 2.66669H4.00011C3.88223 2.66669 3.76919 2.71351 3.68584 2.79686C3.60249 2.88021 3.55566 2.99326 3.55566 3.11113V12.8889C3.55566 13.0068 3.60249 13.1198 3.68584 13.2032C3.76919 13.2865 3.88223 13.3334 4.00011 13.3334H4.44455V12.4445Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.8c9c098c55e8d4ad7c8660290ce57000.svg";
export { ForwardRef as ReactComponent };